import { makeAutoObservable } from 'mobx';

import { FilterStore } from '../../shared/util-stores';
import { resetAllStore } from '../../shared/stores/resetAllStore';
import {
  UnreadScansFilters,
  UnreadScansFilterValues,
  UnreadScansSortField,
} from '../interfaces/UnreadScansFilters';
import { UnreadScansInfo } from '../interfaces/UnreadScansRowInfo';
import { requiredAttentionService } from '../services/requiredAttentionService';
import { unreadScansCountStore } from '../../shared/stores/unreadScansCountStore';
import { SolutionTypeFilter } from '../../shared/constants/user-info/solutionType';

class UnreadScansStore {
  unreadScans: UnreadScansInfo[] = [];
  filterMethods: FilterStore<UnreadScansFilterValues, UnreadScansSortField>;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });

    this.filterMethods = new FilterStore<UnreadScansFilterValues, UnreadScansSortField>(
      this.handleGetUnreadScans,
    );
  }

  setDefaultValues() {
    this.unreadScans = [];
    this.filterMethods.setDefaultValues();
  }

  getUnreadScans(defaultValues: UnreadScansFilterValues) {
    return this.filterMethods.applyFilters(defaultValues);
  }

  private async handleGetUnreadScans(filterInfo: UnreadScansFilters) {
    const response = await requiredAttentionService.getUnreadScans(filterInfo);

    this.setUnreadScans(response.content);

    return response;
  }

  private setUnreadScans(unreadScans: UnreadScansInfo[]) {
    this.unreadScans = unreadScans;
  }

  async readAllScans(solutionType: SolutionTypeFilter) {
    await unreadScansCountStore.markAllScansRead(solutionType);

    await this.getUnreadScans({ solutionType });
  }
}

const unreadScansStore = new UnreadScansStore();
resetAllStore.addResetMethod(unreadScansStore.setDefaultValues);

export { unreadScansStore, UnreadScansStore };
